import React, {Component} from 'react'
import Head from 'next/head'
import {
  getArticlePageTitle,
  socialMeta
} from '../../data/meta'
import {getShareUrl} from '../../utils/social'
import {getHostedImage} from '../../utils/images'

class ArticleMeta extends Component {
  render () {
    const {article} = this.props
    const pageTitle = getArticlePageTitle(article.seoHeadline)
    const image = (article.previewImage) ? getHostedImage(article.previewImage.url) : null
    const url = getShareUrl(article)
    const socialDescription = (article.socialDescription) ? article.socialDescription : '&nbsp;'
    return (
      <Head>
        <title>{pageTitle}</title>
        <link rel='canonical' href={url} />
        <meta name='description' content={article.description} key='description' />
        {socialMeta({
          title: article.socialHeadline,
          description: socialDescription,
          image,
          url
        })}
      </Head>
    )
  }
}

ArticleMeta.defaultProps = {}

export default ArticleMeta



// WEBPACK FOOTER //
// ./client/components/ArticleMeta/ArticleMeta.js